/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import $ from 'jquery'
import PinInput from 'react-pin-input'
import {Button, Input} from 'mdbreact'
import {message} from 'antd'
import {loadBrand} from '../BaseComponent/configTheme'

class ForgetPass extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      resetCode: '',
      username: '',
      newPassword: '',
      errorResetCode: '',
      errorChangePassword: ''
    }
  }
  componentDidMount() {
    $(function() {
      $('.header').hide()
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  submitForm(e) {
    e.preventDefault()
  }

  changeField(e) {
    const target = e.target
    const value = target.value
    const name = target.name
    this.setState({
      [name]: value
    })
  }

  sendResetCode() {
    const {username} = this.state
    const data = {
      username: username
    }
    if (username === '') {
      this.setState({errorResetCode: 'لطفا نام کاربری را وارد کنید'})
    } else {
      http
        .post(`public/user/reset/validation`, data, {})
        .then((response) => {
          //alert(JSON.stringify(response.data))
          if (response.data.error == null) {
            this.setState({errorResetCode: 'یک کد برای شما پیامک شد.لطفا صبر کنید'})
            setInterval(function() {
              $('.modalWrapp').fadeIn()
            }, 2000)
          } else {
            // message.error(response.data.description)
          }
        })
        .catch((error) => {
          console.log(error)
          this.setState({errorResetCode: 'خطا در ورود اطلاعات'})
        })
    }
  }

  changePassword() {
    const {newPassword, resetCode, username} = this.state

    if (resetCode === '') {
      this.setState({
        errorChangePassword: 'لطفا عبارت 5 رقمی ارسال شده را وارد کنید'
      })
    } else if (newPassword === '') {
      this.setState({
        errorChangePassword: 'لطفا کلمه عبور جدید را وارد کنید'
      })
    } else {
      const data = {
        username: username,
        password: this.convertDigit(newPassword),
        resetCode: this.convertDigit(resetCode)
      }

      http
        .post(`public/user/reset/password`, data, {})
        .then((response) => {
          console.log(response.data)
          if (response.data.error == null) {
            this.setState({errorChangePassword: 'تغییر کلمه عبور موفقیت آمیز بود.لطفا صبر کنید'})
            setInterval(function() {
              window.location.assign('./')
            }, 3000)
          } else {
            // message.error(response.data.description)
          }
        })
        .catch((error) => {
          console.log(error)
        })

      this.setState({
        errorChangePassword: ''
      })
    }
  }

  render() {
    return (
      <div>
        <div className="container">
          <div className="modalWrapp">
            <div className="modalContent">
              <form className="forgetPass" onSubmit={this.submitForm.bind(this)}>
                <div className="bannerForm">
                  <p>کد پیامک شده را وارد کنید</p>
                </div>
                <PinInput
                  length={5}
                  onChange={(value, index) => {}}
                  type="numeric"
                  style={{padding: '10px'}}
                  inputStyle={{borderBottomColor: 'red'}}
                  inputFocusStyle={{borderColor: 'blue'}}
                  onComplete={(value) => {
                    this.setState({resetCode: value})
                  }}
                />
                <Input
                  label="کلمه عبور جدید"
                  name="newPassword"
                  group
                  type="password"
                  onChange={this.changeField.bind(this)}
                />

                <p className="errorText">{this.state.errorChangePassword}</p>
                <Button color="success" block onClick={this.changePassword.bind(this)}>
                  تغییر کلمه عبور
                </Button>
              </form>
            </div>
          </div>
          <div className="formWrapperHome" style={{background: loadBrand().color}}>
            <div className="logoHome">
            <img src={loadBrand().logo} alt="logo" />
              <p>به {loadBrand().title} خوش آمدید</p>
            </div>
            <form className="loginForm" onSubmit={this.submitForm.bind(this)}>
              <div className="banerLoginForm">
                <p>فرم فراموشی کلمه عبور</p>
              </div>
              <div className="formComponent">
                <label for="user">نام کاربری</label>
                <input
                  type="text"
                  id="user"
                  name="username"
                  className="form-control"
                  onChange={this.changeField.bind(this)}
                />
                <Button block color="warning" onClick={this.sendResetCode.bind(this)} type="submit" rounded>
                  درخواست رمز عبور جدید
                </Button>
                <p className="errorText">{this.state.errorResetCode}</p>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export default ForgetPass
